var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedicalInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 16H6.75V13.75H9V12.25H6.75V10H5.25V12.25H3V13.75H5.25V16ZM11 12.25H17V11.25H11V12.25ZM11 15.25H15V14.25H11V15.25ZM1.5 20C1.1 20 0.75 19.85 0.45 19.55C0.15 19.25 0 18.9 0 18.5V6.5C0 6.1 0.15 5.75 0.45 5.45C0.75 5.15 1.1 5 1.5 5H7.75V1.5C7.75 1.1 7.9 0.75 8.2 0.45C8.5 0.15 8.85343 0 9.26028 0H10.7397C11.1466 0 11.5 0.15 11.8 0.45C12.1 0.75 12.25 1.1 12.25 1.5V5H18.5C18.9 5 19.25 5.15 19.55 5.45C19.85 5.75 20 6.1 20 6.5V18.5C20 18.9 19.85 19.25 19.55 19.55C19.25 19.85 18.9 20 18.5 20H1.5ZM1.5 18.5H18.5V6.5H12.25V7.25C12.25 7.71667 12.1 8.08333 11.8 8.35C11.5 8.61667 11.1466 8.75 10.7397 8.75H9.26028C8.85343 8.75 8.5 8.61667 8.2 8.35C7.9 8.08333 7.75 7.71667 7.75 7.25V6.5H1.5V18.5ZM9.25 7.25H10.75V1.5H9.25V7.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalInformation);
export default __webpack_public_path__ + "static/media/medical_information.ec8559aa9f4e559e46141a7e5ed6fafc.svg";
export { ForwardRef as ReactComponent };